import { DatePresenter } from '../date-presenter/DatePresenter';
import { EnUsShortDateLocalizer } from '../date-presenter/localizer/en-us-short-date-localizer/EnUsShortDateLocalizer';
import { PstTransformer } from '../date-presenter/pst-transformer/PstTransformer';

/**
 * Takes a date in any timezone, converts it to PST and then formats it as MMM d, yyyy.
 */
export class PstShortDatePresenter extends DatePresenter {
    public constructor () {
        super(new PstTransformer(), new EnUsShortDateLocalizer());
    }
}
